export default __webpack_public_path__ + "static/media/icon_simulator.3d86b3da.svg";